import React, { useContext } from "react";
import { useLocationCtx } from "../../context/LocationContext";
import { AuthContext } from "../../context/AuthContext";
import { useCountryGate } from "../../hooks/useCountryGate";

export default function CountryDebugBadge() {
  const { user } = useContext(AuthContext) || {};
  const {
    guestLoaded,
    guestCountry,
    explicitUserSelectedCountry,
    resolvedCountryId,
    countrySource,
  } = useLocationCtx();
  const { needsCountrySelection } = useCountryGate();
  const shouldShow = process.env.REACT_APP_DEBUG_GUEST_STATE === "1";

  const isAuthenticated = !!user?.id;
  const guestId =
    typeof window !== "undefined"
      ? window.localStorage.getItem("incooking_guest_id")
      : null;

  const row = (label, value) => (
    <div style={{ display: "flex", gap: 6 }}>
      <span style={{ opacity: 0.7 }}>{label}:</span>
      <span style={{ fontWeight: 600 }}>{String(value)}</span>
    </div>
  );

  return (
    shouldShow ? (
    <div
      style={{
        position: "fixed",
        top: 12,
        right: 12,
        zIndex: 9999,
        padding: "8px 10px",
        background: "rgba(0,0,0,0.75)",
        color: "#fff",
        fontSize: 11,
        lineHeight: 1.25,
        borderRadius: 6,
        maxWidth: 220,
        pointerEvents: "none",
      }}
    >
      {row("isAuthenticated", isAuthenticated)}
      {row("guestLoaded", guestLoaded)}
      {row("guestCountry", guestCountry || "")}
      {row("explicitUserSelected", explicitUserSelectedCountry)}
      {row("resolvedCountryId", resolvedCountryId || "")}
      {row("needsCountrySelection", needsCountrySelection)}
      {row("countrySource", countrySource || "")}
      {row("guestId", guestId || "")}
    </div>
    ) : null
  );
}
